<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">  
	<leftnav mkcode="D" itemcode="D-ZSHJ"  :smScrennFull="true"></leftnav> 
		<!-- 弹框 -->	
		<div class="por" style="background-color: #041034;height:100%;">
			<!-- 全屏开始 -->
			<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
			<!-- 全屏结束 -->
			<div class="index-swiper centerpage">
				<!-- <h2 class="title dataswipertitle" @mouseover="drawer = true" >{{userdata.cityText}}</span>{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2> -->
				<daswiperNav :title="title" :indexnum="6" navcode="ZSXM"  :fulltitle="true"></daswiperNav>
				<div class="indexflex zhaoshangmap">
					<div class="col2h  zsxm_left">
						<div class="zsxm_province">
							<h3 class="zsxm_title">接收全国上市公司投资省份来源</h3>
							<div class="zsxm_nav">
								<span class="zsxm_nav_num" :class="pro_nav==1?'zsxm_navbg':''" @click="pro_nav=1">数值</span>
								<span class="zsxm_nav_money" @click="ckfn()" :class="pro_nav==2?'zsxm_navbg':''">金额占比</span>
							</div>
							<div class="" v-show="pro_nav==1">
								<h5 class="zsxm_money">投资金额（亿元）</h5>
								<h5 class="zsxm_num">投资数量（个）</h5>
								<div id="zsxm_province_num"> </div>
							</div>
							<div id="zsxm_province_money" v-show="pro_nav==2" >金额占比图表</div>
						</div>
						<div class="zsxm_city">
							<h3 class="zsxm_title">接收全国上市公司投资城市来源</h3>
							<div class="zsxm_nav"><span class="zsxm_nav_num" @click="city_nav=1" :class="city_nav==1?'zsxm_navbg':''">数值</span><span
									class="zsxm_nav_money" @click="ckfn2()" :class="city_nav==2?'zsxm_navbg':''">金额占比</span></div>
							<div class="" v-show="city_nav==1">
								<h5 class="zsxm_money">投资金额（亿元）</h5>
								<h5 class="zsxm_num">投资数量（个）</h5>
								<div id="zsxm_city_num"></div>
							</div>
							<div id="zsxm_city_money" v-show="city_nav==2" >222</div>
						</div>
						<div class="zsxm_detailed">
							<h3 class="zsxm_title">接收全国上市公司投资项目清单</h3>
							<div class="thbox">
								<ul class="flexcss">
									<li class="th_list1">公司简称</li>
									<li class="th_list4">项目名称</li>
									<li class="th_list2">投资来源</li>
									<li class="th_list2">投资地点</li>
									<li class="th_list3">投资金额（亿元）</li>
								</ul>
							</div>
							<div class="zsxm_scrollbox">
								<vue-seamless-scroll :data="investmentlist"  :class-option="defaultOption" class="qysj_table_list">
									<!-- :data="colors"  :class-option="defaultOption" -->
									<ul class="qysj_tab flexcss" v-for="list in  investmentlist"> 
										<li class="th_list1" @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</li> 
										<li class="th_list4">{{list.projectName}}</li><!-- @click="routerlinkid('/news',item.id)"  id对吗？怎么跳不过去？？？？ -->
										<li class="th_list2" >{{list.source}}</li>
										<li class="th_list2">{{list.area}}</li>
										<li class="th_list3">{{list.money}}</li>
									</ul> 
								</vue-seamless-scroll>
							</div>
						</div>
					</div>
					<div class="col5 colbox">
						<div id="zsxm_map"></div>
					</div>
					<!-- <div class="pos_map">
							
					</div> -->
					<div class="col2h colbox transparentbg">
						<div class="zsxm_industry">
							<h3 class="zsxm_title">接收上市公司投资行业分布</h3>
							<div class="zsxm_nav">
								<span class="zsxm_nav_num" @click="zsxm_nav=1" :class="zsxm_nav==1?'zsxm_navbg':''">数值</span>
								<span class="zsxm_nav_money" @click="ckfn3()" :class="zsxm_nav==2?'zsxm_navbg':''">金额占比</span>
								</div>
							<div v-show="zsxm_nav==1">
								<h5 class="zsxm_money">投资金额（亿元）</h5>
								<h5 class="zsxm_num">投资数量（个）</h5>
								<div id="zsxm_industry_num"></div>
							</div>
							<div id="zsxm_industry_money" v-show="zsxm_nav==2" ></div>
						</div>
						<div class="">
							<h3 class="zsxm_title">接收投资金额全省排名</h3>
							<div id="zsxm_provincerank"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
	import mappng from '../../assets/images/mapbg.png'; 
	export default {
		name: 'zhaoshangditu',
		data() {
			return { 
					isCollapse:false,
					isFullscreen: false,
					direction:"ltr",  //btt
					direction2:"btt",  //btt
					 drawer: false,
						drawer2: false,
						modal:false,	
				title: "招商项目数字大屏",
				bgcolor: "#041034",
				usernotionlistsave: [],
				userdata: {},
				mapurl: 'map/city/321200.json',
				contodefault: {
					duration: 1000,
					autoplay: true,
				},
				islogin: false,
				flag: true,
				swipernum: 3,
				zsxm_nav:1,
				city_nav: 1,
				pro_nav:1,
				listdata: [],
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				}, 
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				landType: [],
				startCharts: null,
				//假数据 
				moydata1: [  //接收全国上市公司投资省份来源 金额占比
					{	value: 95.31,	name: '江苏省'},
					{value: 35.18,name: '宁夏'},
					{value: 16.4,name: '天津'}, 
					{value: 10.16,name: '北京'},
					{value: 9,name: '重庆'},
					{value: 21.5,name: '其他'},
				],
				moydata2: [ 
					{name: '重庆市',value: 9},
					{name: '北京市',value: 10.16},
					{name: '天津市',value: 16.4},
					{name: '银川市',value: 34.78	},
					{name: '泰州市',	value: 88.51},
					{name: '其他',	value: 21.5},
				],
				moydata3: [
					{name: '其他',value: 4.51},
					{name: '农林牧渔',value: 3.23},
					{name: '金融行业',value: 12.2},
					{name: '医疗医药',value: 43.4},
					{name: '化工行业',	value: 56.3},
					{name: '装备制造',	value: 66.37}, 
				],
				moenydata: [  //接收全国上市公司投资省份来源 数值 
					{	city: '北京市',	num: 2,money: 10.16	},
					{city: '江西省',	num: 5,	money: 9},
					{city: '天津市',num: 8,	money: 16.4	},
					{	city: '宁夏',	num: 5,	money: 35.18},
					{	city: '江苏省',	num:42 ,	money: 95.31},
				],
				moenydata2: [  //接收全国上市公司投资城市来源 数值
					{city: '重庆市',num: 5,money: 9},
					{city: '北京市',num: 2,money: 10.16},
					{city: '天津市',num: 8,money: 16.4},
					{city: '银川市',num: 4,money: 34.78	},
					{	city: '泰州市',	num: 32,	money: 88.51},
				],
				moenydata3: [ 
					{city: '农林牧渔',num: 4,	money: 3.23},
					{city: '金融行业',	num: 3,money: 12.2},
					{city: '医疗医药',num: 15,money: 43.4},
					{city: '化工行业',num: 11,	money: 56.3},
					{city: '装备制造',num:33 ,	money: 66.37},
				], 
				fixassetsdata: [
					{	name: "泰州市",		value: 88.51},
					{name: "常州市",value: 3.63},
					{name: "南京市",value: 1.82},
					{name: "无锡市",value: 1.36}, 
				],
				ydata:[
									{name: "北京市", 	value: [116.4,39.9],},
									{name: "天津市", value: [117.2,39.12]}, 
									{name: "河北省",value: [114.52,38.05]},
									{name: "四川",value: [104.06,30.67]	}, 
									{name: "湖北",	value: [114.31,30.51]},
									{name: "山东",	value: [117,36.65]},
									{name: "浙江",value: [118.21,29.11]},
									{name: "江苏",value: [118.78,32.04]},
									{name: "河南",value: [113.65	,34.76]},
									{name: "湖南",value: [113,28.21]},
								 {name: "安徽",value: [117.27,31.86	]},
									{name: "江西",value: [115.89	,28.68	]},
									{name: "福建	",value: [119.3	,26.08]},
									{name: "广东",value: [113.23,23.16	]},
									{name: '云南',value:[102.712251,25.040609]},
									{ name: '陕西',value:[108.948024,34.263161] , },
									{name: '陕西',value:[123.429096,41.796767] ,} 
									], 
			investmentlist:[], 
			zbdata:[],
			zd:[118.767413,32.041544	], //大地图终点坐标
				}
				},
		props: {
			msg: String,
		},
		computed: {
			defaultOption() {
				return {
					step: 0.7, // 数值越大速度滚动越快
					limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		}, 
		
		mounted() {
			let jdata= require('../../../public/map/geo.json');  //引入json文件
			document.getElementById('app').style.background = this.bgcolor;
			this.userdata = this.getuseriformation();
			// console.log(this.userdata);
			this.bus.$emit('loading', true);
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
			this.getajasdata(); 
			// for(var i=0;i<this.zbdata.length;i++){
			// 	 if(this.zbdata[i].name==this.userdata.cityText){
			// 			this.zd=[this.zbdata[i].longitude,this.zbdata[i].latitude];
			// 		}
			// }
			for(var i=0;i<jdata.length;i++){
				 if(jdata[i].name==this.userdata.cityText){
						this.zd=[jdata[i].longitude,jdata[i].latitude];
					}
			}
		},
		methods: {
			ckfn() {
				this.pro_nav=2;
				this.$nextTick(() => { 
				this.PiechartFun('zsxm_province_money',this.moydata1); //接收全国上市公司投资省份来源 金额占比
				})  
			},
			ckfn2(){
				this.city_nav=2;
				this.$nextTick(() => { 
				this.PiechartFun('zsxm_city_money',this.moydata2); //接收全国上市公司投资城市来源 金额占比
				})  
			},
			ckfn3(){
				this.zsxm_nav=2;
				this.$nextTick(() => { 
				this.PiechartFun('zsxm_industry_money',this.moydata3);//接收全国上市公司投资行业分布 金额占比
				})  
			},

			getajasdata() {
				var _this = this;
				// this.bus.$emit('loading', true);
				console.log(this.title);
				this.$axios.get(this.$api.cyl.govsaaschart.investProject(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log(res.data.data);
					if (res.data.success) {
						var datd = res.data.data;
						_this.moydata1 = res.data.data.province;
						_this.moydata2 =  res.data.data.city;
						_this.moydata3 = res.data.data.industry;
						_this.investmentlist = res.data.data.investList;
						_this.numFun('zsxm_province_num', res.data.data.province);  //接收全国上市公司投资省份来源 
						_this.numFun2('zsxm_city_num', res.data.data.city); //接收全国上市公司投资城市来源 
					_this.numFun3('zsxm_industry_num',res.data.data.industry); //接收上市公司投资行业分布
					_this.rankFun('zsxm_provincerank', res.data.data.provinceRank); //接收投资金额全省排名
						_this.chianmapFun('zsxm_map',res.data.data.province,_this.ydata); //地图
						_this.bus.$emit('loading', false);
					} 
				}).catch(function(error) {
					//请求失败处理 console.log(error);
				});
			},

			//1大地图
			chianmapFun(el, data,scdata) {
				console.log('地图',this.zd,scdata);
				var _this =this; 
				for(var i=0;i<data.length;i++){
					if(data[i].name=='内蒙古自治区'||data[i].name=='黑龙江省'){
						data[i].name = data[i].name.substr(0,3); //匹配前三字
						data[i].value = data[i].num;
						data[i].value2 = data[i].money;
					}else{
						data[i].name = data[i].name.substr(0,2); //匹配前两字
						data[i].value = data[i].num;
						data[i].value2 = data[i].money;
					} 
				}  
				
				var myChart = echarts.init(document.getElementById(el));
				// JSON文件(地图数据)路径
				var loadedDataURL = 'map/china.json';
				let cityCode = 'china';
				// 显示加载动画效果,可以在加载数据前手动调用该接口显示加载动画，在数据加载完成后调用 hideLoading 隐藏加载动画。
				// myChart.showLoading();
				let mapName = cityCode;
				$.getJSON(loadedDataURL, function(geoJson) {
					// console.log('geoJson:', geoJson)
					// 注册地图名字(tongren)和数据(geoJson) 
					echarts.registerMap(mapName, geoJson);
					// 隐藏动画加载效果。
					myChart.hideLoading();
					// 图表配置项
					var option = {
						backgroundColor: this.bgcolor,
						selectedMode: 'multiple', // 选中效果固话
						tooltip: { // 提示框
							show: true,
							trigger: 'item',
							formatter: function(params) {
								// console.log(params)
								return params.name;
							}
						},
						geo: {
							map: mapName,
							aspectScale: .9,
							layoutCenter: ['49.3%', '50.5%'],
							layoutSize: '110%',
							silent: true,
							roam: false,
							center: [105.87, 37.2],
							z: 0,
							itemStyle: {
								normal: {
									areaColor: 'rgba(0, 0, 0, 0)', //底图背景色
									shadowColor: 'rgba(0, 0, 0, 1)',
									shadowBlur: 0,
									shadowOffsetX: 0,
									shadowOffsetY: 1,
									borderColor: '#07232c',
									borderWidth: 0.5,
								},
								emphasis: {
									areaColor: 'rgba(0,0,0,0)',
									borderWidth: 1,
									color: 'green',
									label: {
										show: true,
									},
								},
							},
						},
						series: [{
							name: 'map',
							type: "map", // map3D / map
							map: mapName,
							zoom: 1.18,
							label: { // 标签的相关设置
								show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
								// distance: 5, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离
								//formatter:, // 标签内容格式器
								textStyle: { // 标签的字体样式
									color: '#ffffff', // 地图初始化区域字体颜色 
									fontSize: 14, // 字体大小
									opacity: 1, // 字体透明度 
								},
								emphasis: {
									show: true,
									color: '#ffffff',
								}
							},
							tooltip: { //提示框组件。
								show: true,
								alwaysShowContent: true,
								hoverAnimation: true,
								trigger: 'item', //触发类型 散点图
								enterable: true, //鼠标是否可进入提示框
								transitionDuration: 1, //提示框移动动画过渡时间
								triggerOn: 'click',
								borderWidth: '1px',
								borderRadius: '4',
								// borderColor: '#00B2AC',
								backgroundColor: "rgba(0,0,0,.6)",
								textStyle: {
									color: 'rgba(255,255,255,1)'
								},
								padding: [10, 10],
								formatter: function(params) {
									var result = '';
									if (!isNaN(params.value)) {
										result = '投资金额（亿元）：' + params.data.value2 + '<br>' +
											'投资数量（个）：' + params.value;
									} else {
										result = '省份：' + params.name;
									}
									// console.log(params);
									return result;
								},

							},
							itemStyle: { // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
								// areaColor: 'rgba(95,158,160,0.5)', // 地图板块的颜色
								areaColor: '#2e579d', // 地图板块的颜色
								opacity: 1, // 图形的不透明度 [ default: 1 ]
								borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
								borderColor: '#fff' // 图形描边的颜色。[ default: #333 ]
							},
							emphasis: {
								show: true,
								itemStyle: {
									areaColor: '#0e2240', // 地图板块的颜色
									opacity: 1, // 图形的不透明度 [ default: 1 ]
									borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
									borderColor: '#fff', // 图形描边的颜色。[ default: #333 ]

								}
							},
							// zoom:1.2,	
							data: data,

						},
						{
																	type:"effectScatter",       //带有涟漪特效动画的散点（气泡）图。
																	data:scdata,
																	coordinateSystem:'geo',     //'geo',使用地理坐标系/ 该系列使用的坐标系，'cartesian2d',使用二维的直角坐标系/'polar'使用极坐标系，
																	rippleEffect:{              //涟漪特效相关配置。
																					scale:5,        // 波纹的最大缩放比例
																					color:'#e4bb38',        //涟漪颜色
																					period:3,       // 动画的周期，秒数
																					brushType:'fill'      // 波纹样式：'stroke'  ，'fill'
																	},
																	         symbol:'',						   //散点形状设置symbol: 'circle’, ‘rect’, ‘roundRect’, ‘triangle’, ‘diamond’, ‘pin’, 'arrow’
																										symbolSize:'5',
																	        itemStyle:{
																	            normal:{
																	                color:'#e4bb38',		//圆点颜色
																	                shadowColor:'',   //圆点阴影
																	                // shadowBlur:3,
																	                // shadowOffsetX:1,
																	                // shadowOffsetY:2
																	            }
																	        },
													},
													{
													            type: 'lines', // 线数据
													            zlevel: 1,
													            effect: {
													              show: true,
													              period: 0.8, // 箭头指向速度，值越小速度越快
													              trailLength: 0.01, // 特效尾迹的长度。取从 0 到 1 的值，数值越大尾迹越长。
													              symbol: 'triangle', // 特效图形的标记。
													              symbolSize: 5 // 特效标记的大小
													            },
													            lineStyle: {
													              normal: {
													                width: 2, // 尾迹线条宽度
													                color: '#e4bb38', // 线颜色
													                opacity: 0, // 尾迹线条透明度
													                curveness: 0.2 ,// 边的曲度，支持从 0 到 1 的值，值越大曲度越大。 
													              }
													            }, 
													            data:[{
													                fromName: '北京', // 起点城市name
													                toName: '江苏', // 终点城市name
													                value: 2, // value值
													                coords: [
													                  [116.4,39.9], // 起点城市坐标
													                 _this.zd // 终点城市坐标
													                ]
													              },
																											{
																											  fromName: '天津', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											    [117.2,39.12], // 起点城市坐标
																											   _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '河北', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											    [114.52,38.05], // 起点城市坐标
																											   _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '四川', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											   [104.06,30.67], // 起点城市坐标
																											  _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '湖北', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											   [114.31,30.51], // 起点城市坐标
																											  _this.zd// 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '山东', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											   [117,36.65], // 起点城市坐标
																											  _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '浙江', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											   [118.21,29.11], // 起点城市坐标
																											  _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '河南', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											  [113.65	,34.76], // 起点城市坐标
																											  _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '湖南', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											   [113,28.21], // 起点城市坐标
																											   _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '安徽', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											    [117.27,31.86	], // 起点城市坐标
																											  _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '江西', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											   [115.89	,28.68	], // 起点城市坐标
																											  _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '福建', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											   [119.3	,26.08], // 起点城市坐标
																											  _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '广东', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											   [113.23,23.16	], // 起点城市坐标
																											  _this.zd // 终点城市坐标
																											  ]
																											},
																											{
																											  fromName: '云南', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											    [102.712251,25.040609] , // 起点城市坐标
																														_this.zd // 终点城市坐标
																											  ]
																											},
													              {
													                fromName: '陕西', // 起点城市name
													                toName: '江苏', // 终点城市name
													                value: 2, // value值
													                coords: [
													                  [108.948024,34.263161] , // 起点城市坐标
													              			_this.zd // 终点城市坐标
													                ]
													              },
																											{
																											  fromName: '陕西', // 起点城市name
																											  toName: '江苏', // 终点城市name
																											  value: 2, // value值
																											  coords: [
																											    [123.429096,41.796767] , // 起点城市坐标
																														_this.zd // 终点城市坐标
																											  ]
																											},
													            ]							
													          },
													       
						],
					};
					option.series[0].center = [105.87, 36.8];
					// 设置图表实例的配置项以及数据，万能接口，所有参数和数据的修改都可以通过setOption完成，ECharts 会合并新的参数和数据，然后刷新图表。
					myChart.setOption(option);
				});
			},


			//饼图fn
			PiechartFun(el, data) { 
				console.log('进入饼图');
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var regionalchart = echarts.init(document.getElementById(el));
				for(var i=0;i<data.length;i++){
					data[i].value = data[i].money;
				}
				var _this = this;
				var option = {
					title: {
						text: ' ',
					},
					tooltip: {
						trigger: 'item'
					},
					// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
					// },
					series: [{
						name: '',
						type: 'pie',
						radius: '55%',
						// center: ["52%", "50%"],
						data: data,
						label: {
							show: true,
							color: '#eee',
							fontSize: 12,
							position: 'outside',
							formatter: '{b} : {d}%',
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				regionalchart.setOption(option);
				setTimeout(function() {
					window.onresize = function() {
						regionalchart.resize();
					}
				}, 200)
			},

			//1
			numFun(el, data) {
				console.log(data);
				var projectchart = echarts.init(document.getElementById(el));
				// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
				var _this = this,
					xdata1 = [],
					xdata2 = [],
					yData = [];
				for (var i = 0; i < data.length; i++) {
					xdata1.push(data[i].money);
					xdata2.push(data[i].num);
					// data[i].city=data[i].name;
					yData.push(data[i].name);
				} 
				var option = {
					title: {
						text: ''
					},
					tooltip: {
						formatter: "{b}：{a}{c}",
						confine: true, //提示框被遮挡  是否将 tooltip 框限制在图表的区域内 
					},
					grid: [{ // 左侧对应坐标系
							show: false,
							left: '10%',
							top: '10%',
							bottom: '10%',
							width: '40%'
						},
						{ // 右侧对应坐标系
							show: false,
							left: '51%',
							top: '10%',
							bottom: '10%',
							width: '40%'
						},
						{ // 用来显示的坐标系
							show: false,
							left: '15%',
							top: '10%',
							bottom: '10%',
							width: '80%'
						}
					],
					// x轴是度量，y轴是维度
					xAxis: [{ // 左侧轴
							type: 'value',
							inverse: true,
							min: 0,
							// max: val => {
							//     return Math.floor((val.max) * 1.1);
							// }, 
							axisLine: { //轴线
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false, //轴标签
								textStyle: {
									color: '#999',
									fontSize: 12
								}
							},
							splitLine: {
								show: false
							}
						},
						{ // 右侧轴
							type: 'value',
							gridIndex: 1,
							min: 0,
							// max: val => {
							//     return Math.floor((val.max) * 1.1);
							// },
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								textStyle: {
									color: '#999',
									fontSize: 12
								}
							},
							splitLine: {
								show: false
							}
						},
						{ // 最左侧y轴对应x轴
							gridIndex: 2,
							name: 'x',
							nameLocation: 'center',
							nameGap: 40, // 与坐标轴距离
							nameTextStyle: {
								color: '#999999',
								fontSize: 12
							},
							axisLine: {
								show: false
							}
						}
					],
					yAxis: [{
							type: 'category',
							position: 'right',
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								margin: 0
							},
							data: yData
						},
						//右侧y轴
						{
							gridIndex: 1,
							type: 'category',
							position: 'left',
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false,
							},
							axisLabel: {
								show: false
							},
							data: yData
						},
						{
							name: '',
							gridIndex: 2,
							type: 'category',
							position: 'left',
							nameLocation: 'end',
							nameGap: 25, // 与坐标轴距离
							nameTextStyle: {
								color: '#999999',
								fontSize: 12
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								textStyle: {
									color: '#000',
									fontSize: 12
								}
							},
							data: yData
						}
					],
					series: [{
							name: '投资金额(亿元)',
							type: 'bar',
							xAxisIndex: 0,
							yAxisIndex: 0,
							// barWidth: '20%',
							itemStyle: { //通常情况下：
								normal: {
									//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
									// color: function(params) {
									// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518','#a8c3ef','#e98eef','#efb1a4','#ef6e2d','#00ffff','#ecef15','#aa0000','#005500','#55557f','#5500ff','#ffff7f','#55aaff','#b1efaa','#aa55ff','#aaaa7f','#6a5bef',];
									// 	return colorList[params.dataIndex];
									// }
									// color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
								},
							},
							label: {
								normal: {
									show: false,
									position: 'left', //显示顶部数据
									color: '#fff',
								}
							},
							data: xdata1,
							// barCategoryGap:'5%',
						},
						{
							name: '投资数量（个）',
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 1,
							// barMaxWidth: '20%',
							itemStyle: { //通常情况下：
								normal: {
									//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
									// color: function(params) {
									// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518','#6a5bef',];
									// 	return colorList[params.dataIndex];
									// }
									// color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
								},
							},
							label: {
								normal: {
									show: false,
									position: 'right', //显示顶部数据
									color: '#fff',
								}
							},
							data: xdata2,
						}
					]
				};
				projectchart.setOption(option);
			},

			//2
			numFun2(el, data) { 
				var projectchart = echarts.init(document.getElementById(el));
				// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
				var _this = this,
					xdata1 = [],
					xdata2 = [],
					yData = [];
				for (var i = 0; i < data.length; i++) {
					xdata1.push(data[i].money);
					xdata2.push(data[i].num); 
					yData.push(data[i].name);
				}  
				var option = {
					title: {
						text: ''
					},
					tooltip: {
						formatter: "{b}：{a}{c}"
					},
					grid: [{ // 左侧对应坐标系
							show: false,
							left: '10%',
							top: '10%',
							bottom: '10%',
							width: '40%'
						},
						{ // 右侧对应坐标系
							show: false,
							left: '51%',
							top: '10%',
							bottom: '10%',
							width: '40%'
						},
						{ // 用来显示的坐标系
							show: false,
							left: '15%',
							top: '10%',
							bottom: '10%',
							width: '80%'
						}
					],
					// x轴是度量，y轴是维度
					xAxis: [{ // 左侧轴
							type: 'value',
							inverse: true,
							min: 0,
							// max: val => {
							//     return Math.floor((val.max) * 1.1);
							// }, 
							axisLine: { //轴线
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false, //轴标签
								textStyle: {
									color: '#999',
									fontSize: 12
								}
							},
							splitLine: {
								show: false
							}
						},
						{ // 右侧轴
							type: 'value',
							gridIndex: 1,
							min: 0,
							// max: val => {
							//     return Math.floor((val.max) * 1.1);
							// },
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								textStyle: {
									color: '#999',
									fontSize: 12
								}
							},
							splitLine: {
								show: false
							}
						},
						{ // 最左侧y轴对应x轴
							gridIndex: 2,
							name: 'x',
							nameLocation: 'center',
							nameGap: 40, // 与坐标轴距离
							nameTextStyle: {
								color: '#999999',
								fontSize: 12
							},
							axisLine: {
								show: false
							}
						}
					],
					yAxis: [{
							type: 'category',
							position: 'right',
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								margin: 0
							},
							data: yData
						},
						//右侧y轴
						{
							gridIndex: 1,
							type: 'category',
							position: 'left',
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false,
							},
							axisLabel: {
								show: false
							},
							data: yData
						},
						{
							name: '',
							gridIndex: 2,
							type: 'category',
							position: 'left',
							nameLocation: 'end',
							nameGap: 25, // 与坐标轴距离
							nameTextStyle: {
								color: '#999999',
								fontSize: 12
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								textStyle: {
									color: '#000',
									fontSize: 12
								}
							},
							data: yData
						}
					],
					series: [{
							name: '投资金额(亿元)',
							type: 'bar',
							xAxisIndex: 0,
							yAxisIndex: 0,
							// barWidth: '20%',
							itemStyle: { //通常情况下：
								normal: {
									//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
									// color: function(params) {
									// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518','#6a5bef'];
									// 	return colorList[params.dataIndex];
									// }
								},
							},
							label: {
								normal: {
									show: false,
									position: 'left', //显示顶部数据
									color: '#fff',
								}
							},
							data: xdata1,
							// barCategoryGap:'5%',
						},
						{
							name: '投资数量（个）',
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 1,
							// barMaxWidth: '20%',
							itemStyle: { //通常情况下：
								normal: {
									//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
									// color: function(params) {
									// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
									// 	'#6a5bef'];
									// 	return colorList[params.dataIndex];
									// }
								},
							},
							label: {
								normal: {
									show: false,
									position: 'right', //显示顶部数据
									color: '#fff',
								}
							},
							data: xdata2,
						}
					]
				};
				projectchart.setOption(option);
			},
			//3
			numFun3(el, data) {
				var projectchart = echarts.init(document.getElementById(el));
				// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
				var _this = this,
					xdata1 = [],
					xdata2 = [],
					yData = [];
				for (var i = 0; i < data.length; i++) {
					xdata1.push(data[i].money);
					xdata2.push(data[i].num);
					yData.push(data[i].name);
				} 
				var option = {
					title: {
						text: ''
					},
					tooltip: {
						formatter: "{b}：{a}{c}"
					},
					grid: [{ // 左侧对应坐标系
							show: false,
							left: '10%',
							top: '10%',
							bottom: '10%',
							width: '40%'
						},
						{ // 右侧对应坐标系
							show: false,
							left: '51%',
							top: '10%',
							bottom: '10%',
							width: '40%'
						},
						{ // 用来显示的坐标系
							show: false,
							left: '15%',
							top: '10%',
							bottom: '10%',
							width: '80%'
						}
					],
					// x轴是度量，y轴是维度
					xAxis: [{ // 左侧轴
							type: 'value',
							inverse: true,
							min: 0,
							// max: val => {
							//     return Math.floor((val.max) * 1.1);
							// }, 
							axisLine: { //轴线
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false, //轴标签
								textStyle: {
									color: '#999',
									fontSize: 12
								}
							},
							splitLine: {
								show: false
							}
						},
						{ // 右侧轴
							type: 'value',
							gridIndex: 1,
							min: 0,
							// max: val => {
							//     return Math.floor((val.max) * 1.1);
							// },
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								textStyle: {
									color: '#999',
									fontSize: 12
								}
							},
							splitLine: {
								show: false
							}
						},
						{ // 最左侧y轴对应x轴
							gridIndex: 2,
							name: 'x',
							nameLocation: 'center',
							nameGap: 40, // 与坐标轴距离
							nameTextStyle: {
								color: '#999999',
								fontSize: 12
							},
							axisLine: {
								show: false
							}
						}
					],
					yAxis: [{
							type: 'category',
							position: 'right',
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								margin: 0
							},
							data: yData
						},
						//右侧y轴
						{
							gridIndex: 1,
							type: 'category',
							position: 'left',
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false,
							},
							axisLabel: {
								show: false
							},
							data: yData
						},
						{
							name: '',
							gridIndex: 2,
							type: 'category',
							position: 'left',
							nameLocation: 'end',
							nameGap: 25, // 与坐标轴距离
							nameTextStyle: {
								color: '#999999',
								fontSize: 12
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ccc'
								}
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false,
								textStyle: {
									color: '#000',
									fontSize: 12
								}
							},
							data: yData
						}
					],
					series: [{
							name: '投资金额(亿元)',
							type: 'bar',
							xAxisIndex: 0,
							yAxisIndex: 0,
							// barWidth: '20%',
							itemStyle: { //通常情况下：
								normal: {
									//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
									// color: function(params) {
									// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
									// 	'#6a5bef','#c1a5d5'];
									// 	return colorList[params.dataIndex];
									// }
								},
							},
							label: {
								normal: {
									show: false,
									position: 'left', //显示顶部数据
									color: '#fff',
								}
							},
							data: xdata1,
							// barCategoryGap:'5%',
						},
						{
							name: '投资数量（个）',
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 1,
							// barMaxWidth: '20%',
							itemStyle: { //通常情况下：
								normal: {
									//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
									// color: function(params) {
									// 	 var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
									// 	'#6a5bef','#c1a5d5'];
									// 	return colorList[params.dataIndex];
									// }
								},
							},
							label: {
								normal: {
									show: false,
									position: 'right', //显示顶部数据
									color: '#fff',
								}
							},
							data: xdata2,
						}
					]
				};
				projectchart.setOption(option);
			},


			//接收投资金额全省排名
			rankFun(el, data) {
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var chart = echarts.init(document.getElementById(el));
				var _this = this,
					xline = [],
					seriesline = [];
				var datalen = data.length - 1;
				for (var i = 0; i < data.length; i++) {
					xline.push(data[datalen - i].city);
					seriesline.push(data[datalen - i].data);
				};
				// console.log(data,xline,seriesline)
				var option = {
					title: {
						text: "",
						left: 25,
						top: 20,
						textStyle: {
							color: '#eee',
							fontSize: 16
						}
					},
					tooltip: {
						formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>接受投资金额（亿元）{b}：{c}"
					},
					color: _this.colors,
					grid: {
						x: 78,
						y: 10,
						x2: 50,
						y2: 20,
						show: true,
						borderWidth: 0,
					},
					label: {
						show: false,
						position: 'right',
						valueAnimation: true,
						color: '#fff',
						formatter: '{@score}' + '亿元'
					},
					xAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						boundaryGap: [0, 0.01],
						splitLine: {
							show: false
						},
						axisLabel: {  
								fontSize: 13,
								color: '#eee'
						}
					},
					yAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: true
						},
						data: xline,
						axisLabel: {
							fontSize: 13,
							color: '#eee'
						}
					},
					series: [{
						data: seriesline,
						type: 'bar',
						barWidth: 20,
					}]
				};
				chart.setOption(option);
				var startCharts = null;
				// 2、鼠标移动上去的时候的高亮动画
				chart.on('mouseover', function(param) {
					isSet = false
					clearInterval(startCharts)
					// 取消之前高亮的图形
					chart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 高亮当前图形
					chart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
					// 显示 tooltip
					chart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
				});
				var chartHover = function() {
					var dataLen = option.series[0].data.length
					// 取消之前高亮的图形
					chart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
					// 高亮当前图形
					chart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 显示 tooltip
					chart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
				}
				startCharts = setInterval(chartHover, 2000)
				// 4、鼠标移出之后，恢复自动高亮
				chart.on('mouseout', function(param) {
					if (!isSet) {
						startCharts = setInterval(chartHover, 2000)
						isSet = true
					}
				});
			},
		}
	}
</script>

<style scoped="scoped">
	#app{
			background-color: #041034;
		}
	@import url("../../css/dataswiper.css");
</style>
